import moment from 'moment';
import { formatInspection } from 'utils/inspectionStatus';

export const dataColumns = [
  {
    name: 'Cód. vistoria',
    selector: (row) => row?.inspection_code,
    width: '10%',
    sortable: true,
  },
  {
    name: 'Tipo',
    selector: (row) => (row?.parent_inspection ? 'Complementar' : 'Inicial'),
    width: '15%',
    sortable: true,
  },
  {
    name: 'Status',
    selector: (row) => formatInspection(row?.status),
    width: '15%',
    sortable: true,
  },
  {
    name: 'Fotos enviadas',
    selector: (row) => row?.taken_photos?.length || 0,
    width: '15%',
    sortable: true,
  },
  {
    name: 'Solicitada em',
    selector: (row) => moment(row?.created_at).format('DD/MM/YYYY HH:mm'),
    width: '10%',
    sortable: true,
  },
];
